import { CommonModule, NgIf } from '@angular/common'
import { Component, Input } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { environment } from '../../../../environments/environment.prod'
import { AlertHistoryComponent } from './alerthistory'
import { MiddleService } from './middle.service'
@Component({
    selector: 'gd-dropdown',
    template: `
    <div [formGroup]="form">
      <kendo-dropdownlist
        [formControlName]="field.name"
        [id]="field.name"
        *ngIf="
          field.name === 'MutualFundClass' &&
          field.name !== 'AlertRepTextselect'
        "
        (selectionChange)="selectionChanger($event)"
        [style]="calculateStyle()"
        [data]="field.options"
        [valueField]="'key'"
        [textField]="'label'"
        [valuePrimitive]="true"
      >
      </kendo-dropdownlist>
      <kendo-dropdownlist
        [formControlName]="field.name"
        [id]="field.name"
        *ngIf="
          field.name !== 'MutualFundClass' &&
          field.name !== 'AlertRepTextselect' && field.name !== 'StatusTypeID'
        "
        (selectionChange)="selectionChanger($event)"
        [style]="calculateStyle()"
        [data]="field.options"
        [valueField]="'key'"
        [textField]="'label'"
        [valuePrimitive]="true"
      >
      </kendo-dropdownlist>
      <!--  && showViewhistorybtn !== false -->
      <!-- <kendo-dropdownlist
        *ngIf="field.name === 'AlertRepTextselect'"
        [formControlName]="field.name"
        [id]="field.name"
        (selectionChange)="selectionChanger($event)"
        style="width: 350px;"
        [data]="field.options"
        [valueField]="'key'"
        [textField]="'label'"
        [valuePrimitive]="true"
      >
      </kendo-dropdownlist
      >&nbsp;&nbsp;&nbsp; -->
      <span
        *ngIf="
          field.name === 'AlertRepTextselect' && showViewhistorybtn === true
        "
      >
        <button
          type="button"
          kendobutton
          size="tiny"
          class="k-button"
          (click)="toggleAlertHistory()"
        >
          View Alert History
        </button>
      </span>
      <span
        *ngIf="validinfo"
        style="color:red; font-size:11px;padding-left:5px;"
      >
        Warning
      </span>
    </div>
    <gd-dialog-history-alert
      *ngIf="showAlertHistoryPopup"
      (closeEmitter)="toggleAlertHistory()"
    ></gd-dialog-history-alert>
  `,
    imports: [
      CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgIf,
        KENDO_DROPDOWNS,
        AlertHistoryComponent,
    ]
})
export class DropDownComponent {
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  @Input() width = '350px'
  @Input() height = '20px'
  finalWidth: number
  finalHeight: number
  public validinfo: boolean
  public rowStatus = false
  public warningStatus = false
  public warnmsg = environment.warningSurrender
  public showViewhistorybtn: boolean
  public showAlertHistoryPopup = false

  constructor(private metamsg: MiddleService, private route: ActivatedRoute) {
    this.validinfo = false
    this.rowStatus = false
    this.onloadchanges()
  }
  public openmodel() {
    this.metamsg.changeBool(true)
  }
  public toggleAlertHistory() {
    this.showAlertHistoryPopup = !this.showAlertHistoryPopup
  }
  selectionChanger(event: { key: string }) {
    if (event.key !== 'CUSTOM') {
      if (this.form.get('AlertRepTextselect').value === 'CUSTOM') {
        localStorage.setItem(
          'UnsavedAlertText',
          this.form.get('AlertRepText').value,
        )
      }
    }

    if (event.key === 'NIGO') {
      this.form.get('AlertRepText').setValue('')
      this.form.get('AlertRepText').setValue(environment.alertreptxt)
      return
    }
    if (event.key === 'PENDING ALERT') {
      this.form.get('AlertRepText').setValue('')
      this.form.get('AlertRepText').setValue(environment.alertpendingtxt)
      return
    }
    if (event.key === 'CUSTOM') {
      this.form
        .get('AlertRepText')
        .setValue(localStorage.getItem('UnsavedAlertText'))
      return
    }
    if (event.key === 'Missing') {
      this.validinfo = true
      return
    } else {
      this.validinfo = false
      return
    }
  }
  onloadchanges() {
    this.showViewhistorybtn = false
    if (this.route.snapshot.queryParams['Rview']) {
      this.route.queryParams.subscribe(() => {
        this.showViewhistorybtn = true
      })
    }
  }

  calculateStyle() {
    return {
      width: this.width,
      height: this.height,
    }
  }
}
